import React from "react";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";

export default function TestPageDefault() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const aplSettings = AplSettingsSelector();

    // const notify = () => toast("Wow so easy!");

    return (
        <React.Fragment>
            <div>TestPageDefault</div>
            
            {/* <LabelsPrintBasic isPrinting={false} lineDescription="123" workorder="123456780" materialDescription="awesome material desc" nextSequence={234} onPrint={() => {}} /> */}

            {/* <div className="modal show" style={{ display: "block", position: "initial" }}>
                <Modal.Dialog>
                    <Modal.Header closeButton>
                        <Modal.Title>Modal title</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Modal body text goes here.</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                alert("foo");
                            }}
                        >
                            Close
                        </Button>
                        <Button variant="primary">Save changes</Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </div>

            <div className="row">
                <div className="col-6">
                    <button type="button" className="btn btn-primary" id="liveToastBtn">
                        Show live toast
                    </button>

                    <div className="position-fixed bottom-0 right-0 p-3" style={{ zIndex: 5, right: 0, bottom: 0 }}>
                        <div id="liveToast" className="toast hide" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">
                            <div className="toast-header">
                                <img src="..." className="rounded mr-2" alt="..." />
                                <strong className="mr-auto">Bootstrap</strong>
                                <small>11 mins ago</small>
                                <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="toast-body">Hello, world! This is a toast message.</div>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <button onClick={notify}>Notify!</button>
                    <ToastContainer position="bottom-right" />
                </div>
            </div> */}
        </React.Fragment>
    );
}
